"use client";

import type { AuthTab } from "@casino/ui/Games/hooks/useAuthGate";
import { createContext } from "react";

// Defaults to null, not a no-op, so consumers can tell ProfileForm from the legacy popover.
const AuthTabContext = createContext<((tab: AuthTab) => void) | null>(null);

export default AuthTabContext;
